module.exports = __webpack_public_path__ + "kn.6819c37b.svg";